export const patentFields = [
    // 专利更新
    'NEW',
    // 首次公开
    'INVENTION',
    // 被引用更新
    'CITED',
    // 简单同族专利更新
    'ORIGINAL_FAMILY',
    // Patsnap同族专利更新
    'INPADOC',
    // INPADOC同族专利更新
    'INPADOC_FAMILY'
];

export const legalFields = [
    // 法律状态变更
    'LEGAL',
    // 权利转移
    'ASSIGNMENT',
    // 即将过期提醒
    'EXPIRED',
    // 专利许可
    'LICENSE',
    // 复审/无效/上诉提醒
    'REEXAMINVALID',
    // 专利诉讼
    'LITIGATION',
    // 命令(美国专利诉讼)
    'LITIGATION_US_ORDER',
    // 判决(美国专利诉讼)
    'LITIGATION_US_JUDGEMENT',
    // 上诉(美国专利诉讼)
    'LITIGATION_US_APPEAL',
    // up专利提醒
    'UPC',
    // PCT进入国家阶段提醒
    'PCT_ENTRY'
];

export const workspaceFields = [
    // 注释
    'COMMENTS',
    // 自定义字段
    'CUSTOM_FIELD'
];

export const legalAclCheckList = [
    'LITIGATION',
    'LICENSE',
    'LITIGATION_US_ORDER',
    'LITIGATION_US_JUDGEMENT',
    'LITIGATION_US_APPEAL',
    'REEXAMINVALID',
    'UPC'
];

export const aclKeyMap = {
    'LITIGATION': 'litigation',
    'LICENSE': 'licensing',
    'LITIGATION_US_ORDER': 'litigation',
    'LITIGATION_US_JUDGEMENT': 'litigation',
    'LITIGATION_US_APPEAL': 'litigation',
    'REEXAMINVALID': 'reexamInvalid',
    'UPC': 'legal_upc'
};

export const defaultSelectFields = ['NEW', 'LEGAL'];

export const defaultSelectFieldsWhenOverLimit = ['NEW'];

export const CN_FILE_WRAPPER_TYPE = [
    'CN_FILEWRAPPER_OFFICE_ACTION', // 实审意见通知书
    'CN_FILEWRAPPER_NOTIFICATION_TO_GRANT_PATENT_RIGHT', // 办理登记通知书
    'CN_FILEWRAPPER_NOTICE_OF_TERMINATION_OF_RIGHT', // 权利终止通知书
    'CN_FILEWRAPPER_REPORT_ON_PATENT_EVALUATION', // 专利权评价报告
    'CN_FILEWRAPPER_NOTICE_OF_AVOID_DOUBLE_PATENTING' // 避重授权通知书
];

export const US_FILE_WRAPPER_TYPE = [
    'FILEWRAPPER_ALL_EVENTS', // 全部事件和通知
    'FILEWRAPPER_OFFICE_ACTION', // 官方审查意见通知书
    'FILEWRAPPER_APPLICATION_DOCS', // 申请文件
    'FILEWRAPPER_ARGUMENTS_APPLICANT_RESPONSES' // 申请人答复意见
];

export const EP_FILE_WRAPPER_TYPE = [
    'EP_FILEWRAPPER_ALL_EVENTS', // 全部事件和通知
    'EP_FILEWRAPPER_OFFICE_ACTION', // 官方审查意见通知书
    'EP_FILEWRAPPER_APPLICATION_DOCS', // 申请文件
    'EP_FILEWRAPPER_ARGUMENTS_APPLICANT_RESPONSES', // 申请人答复意见
    'EP_FILEWRAPPER_OTHERS_EVENTS' // 其他类型
];

export const ANALYTICS_EMAIL_LIMIT_COUNT = 200;

// 公司监控模板
export const MONITOR_COMPANY_TYPE = [
    'NEW',
    'INVENTION',
    'CITED',
    'ORIGINAL_FAMILY',
    'LEGAL',
    'ASSIGNMENT',
    'REEXAMINVALID',
    'LITIGATION',
    'UPC'
];

// 技术监控模板
export const MONITOR_TECHNOLOGY_TYPE = [
    'NEW',
    'INVENTION',
    'CITED',
    'LEGAL',
    'EXPIRED',
    'LICENSE'
];


export const ALL_FILE_WRAPPER_TYPE = [
    'FILEWRAPPER_ALL_EVENTS', // 全部事件和通知 CN/US/EP/JP
    'FILEWRAPPER_OFFICE_ACTION', // 官方审查意见通知书 CN/US/EP/JP
    'FILEWRAPPER_APPLICATION_DOCS', // 申请文件 US/EP/JP
    'FILEWRAPPER_ARGUMENTS_APPLICANT_RESPONSES', // 申请人答复意见 US/EP/JP
    'FILEWRAPPER_OTHERS_EVENTS', // 其他类型  EP/JP
    'CN_FILEWRAPPER_NOTIFICATION_TO_GRANT_PATENT_RIGHT', // 办理登记通知书 CN
    'CN_FILEWRAPPER_NOTICE_OF_TERMINATION_OF_RIGHT', // 权利终止通知书 CN
    'CN_FILEWRAPPER_REPORT_ON_PATENT_EVALUATION', // 专利权评价报告 CN
    'CN_FILEWRAPPER_NOTICE_OF_AVOID_DOUBLE_PATENTING' // 避重授权通知书 CN
];

/**
 * 获取文件类型对应的区域信息
 * @param {string} type - 文件类型
 * @returns {string} 区域信息，例如：'CN/US/EP/JP'
 */
export function getFileWrapperTypeRegions(type, i18n) {
    const typeRegionsMap = {
        'FILEWRAPPER_ALL_EVENTS': '',
        'FILEWRAPPER_OFFICE_ACTION': i18n.t('snapBusiness.supportCountries.US_EP_CN_JP'),
        'FILEWRAPPER_APPLICATION_DOCS': i18n.t('snapBusiness.supportCountries.US_EP_JP'),
        'FILEWRAPPER_ARGUMENTS_APPLICANT_RESPONSES':  i18n.t('snapBusiness.supportCountries.US_EP_JP'),
        'FILEWRAPPER_OTHERS_EVENTS': i18n.t('snapBusiness.supportCountries.EP_JP'),
        'CN_FILEWRAPPER_NOTIFICATION_TO_GRANT_PATENT_RIGHT':  i18n.t('snapBusiness.supportCountries.CN'),
        'CN_FILEWRAPPER_NOTICE_OF_TERMINATION_OF_RIGHT': i18n.t('snapBusiness.supportCountries.CN'),
        'CN_FILEWRAPPER_REPORT_ON_PATENT_EVALUATION':  i18n.t('snapBusiness.supportCountries.CN'),
        'CN_FILEWRAPPER_NOTICE_OF_AVOID_DOUBLE_PATENTING':  i18n.t('snapBusiness.supportCountries.CN')
    };

    return typeRegionsMap[type] || '';
}
